import React from "react";
import "./App.css";
import Markup from "./markup/Markup";
import { Provider } from "react-redux";
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <Markup />
      </div>
    </Provider>
  );
}

export default App;
